import { createHighlighter, type Highlighter } from 'shiki';

let highlighterPromise: Promise<Highlighter> | null = null;

const LANGS = ['bash', 'javascript', 'python', 'php', 'go', 'json'];
const THEME = 'github-dark';

export function getHighlighter(): Promise<Highlighter> {
    if (!highlighterPromise) {
        highlighterPromise = createHighlighter({
            themes: [THEME],
            langs: LANGS,
        });
    }
    return highlighterPromise;
}

export async function highlight(code: string, lang: string): Promise<string> {
    try {
        const hl = await getHighlighter();
        return hl.codeToHtml(code, { lang: lang as any, theme: THEME });
    } catch {
        // Fallback plain pre
        return `<pre class="shiki"><code>${escapeHtml(code)}</code></pre>`;
    }
}

function escapeHtml(s: string): string {
    return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
